<template>
  <div>
    <section>
      <div class="moileParticulars">
        <div
          class="video"
          id="videoPlay"
          v-html="iframeHtml"
          v-if="this.previewUrl"
        ></div>
        <div
          style="
            position: relative;
            background: left top no-repeat;
            background-size: 100% 100%;
          "
          v-else
        >
          <img
            :src="this.previewImg"
            v-if="this.previewImg"
            class="previewImg"
          />
          <img
            @click="startStudy()"
            src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/playVideo.png"
            class="playVideo"
            alt=""
          />
        </div>
        <div class="particularsTitle cb">
          <h4 class="videoTitle">
            {{ goodDetail.goodsTypeName }}&nbsp;|&nbsp;{{
              goodDetail.goodsName
            }}
          </h4>
          <p class="LabelTime">
            <span class="times"
              >{{ goodDetail.testHours }}
              <span style="color: #ee0a24">学时</span></span
            >
          </p>
        </div>
        <van-tabs
          v-model="active"
          line-width="0.6rem"
          title-active-color="#000000"
          color="#dc0021"
          title-inactive-color="#999999"
        >
          <van-tab title="目录">
            <div class="particularsTab2">
              <van-collapse v-model="activeNames">
                <van-collapse-item
                  :title="chapters.name"
                  :name="chapters.name"
                  v-for="chapters in goodDetail.chapterList"
                  :key="chapters.id"
                >
                  <ul>
                    <li
                      class="finish"
                      :class="{ activess: section.activess }"
                      v-for="section in chapters.sections"
                      :key="section.id"
                    >
                      <div>
                        <a
                          href="javascript:void(0)"
                          @click="startStudy(section.id)"
                        >
                          <div class="timeUp">
                            <van-icon class="play fl" name="play-circle" />
                            <span class="time fl chaperList_he">{{
                              section.name
                            }}</span>
                            <li>
                              <span
                                :class="
                                  section.studyStatus == '学习中' ? time : ''
                                "
                                >{{ section.studyStatus }}</span
                              >
                              <span v-if="section.studyStatus == '学习中'">{{
                                section.studyTime
                              }}</span>
                            </li>
                            <span
                              v-if="isAdd == 0 && isFree == 0"
                              style="padding-top: 0.133333rem"
                              ><img
                                src="../../../static/images/mobile/lock.png"
                                alt=""
                            /></span>
                          </div>
                          <div class="cb timeDown">
                            <span class="time videoText">{{
                              section.duration
                            }}</span>
                          </div>
                        </a>
                        <div class="cb"></div>
                      </div>
                    </li>
                  </ul>
                </van-collapse-item>
              </van-collapse>
            </div>
          </van-tab>
          <van-tab title="简介">
            <div class="particularsTab">
              <div class="introduce_he">
                <p v-html="goodDetail.goodsDesc"></p>
              </div>

              <div
                class="introduce_he"
                v-if="
                  goodDetail.teacherList && goodDetail.teacherList.length > 0
                "
              >
                <h5>
                  <i class="coursePoint">
                    <img
                      src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/coursePoint.png"
                      alt
                    /> </i
                  >讲师介绍
                </h5>
                <span class="divderLine"></span>
              </div>

              <div
                class="teacher"
                v-for="teacher in goodDetail.teacherList"
                :key="teacher.id"
              >
                <div class="teacherLabel_introduce">
                  <img :src="teacher.photoUrl" class="teacherImg fl" />
                  <div class="fr nameLabel">
                    <h6 class="fl teacherName">{{ teacher.name }}</h6>
                    <p class="fl teach">{{ teacher.teacherDesc }}</p>
                  </div>
                </div>
                <p class="fl">{{ teacher.feature }}</p>
                <div class="cb"></div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </section>
    <van-tabbar v-model="actives">
      <van-tabbar-item to="/mobileHome">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? index.active : index.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/mobileStudy">
        <span>班级</span>
        <template #icon="props">
          <img :src="props.active ? classes.active : classes.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/mobileMy">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? my.active : my.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <van-dialog :show-confirm-button="false" v-model="faceDialogFlag">
      <iframe
        class="faceframe"
        ref="Iframes"
        :src="faceUrl"
        scrolling="no"
        allow="microphone;camera;midi;encrypted-media"
      ></iframe>
    </van-dialog>
  </div>
</template>
<script>
import "@/../static/js/ckplayer/preview_ckplayer.js";
import { Toast } from "vant";
import moment from "moment";
export default {
  data() {
    return {
      faceDialogFlag: false,
      faceUrl: "",
      studyId: "",
      sectionId: "",
      active: 0,
      actives: 1,
      activeNames: [],
      studyList: [], //人脸识别弹出时间节点
      goodDetail: {},
      duration: null,
      courseList: [],
      previewUrl: "", //预览视频地址
      previewImg: "", //预览图片地址
      iframeHtml: "",
      //        showAddStudy:false
      index: {
        active: "../../../static/images/mobile/onIndex.png",
        inactive: "../../../static/images/mobile/index.png",
      },
      classes: {
        active: "../../../static/images/mobile/onClass.png",
        inactive: "../../../static/images/mobile/class.png",
      },
      my: {
        active: "../../../static/images/mobile/onMy.png",
        inactive: "../../../static/images/mobile/my.png",
      }, //table栏
      isAdd: "",
      endDurationTime: "",
      time: "",
      isFree: "",
      faceTimeout: null,
      faceFlag: true,
    };
  },
  methods: {
    // 根据视频播放时长跳人脸识别弹框
    showFaceDialog() {
      this.$nextTick(() => {
        this.faceTimeout = setInterval(() => {
          if (this.faceFlag) {
            window.frames[0].postMessage("getCurrentTime", "*");
          }
        }, 1000);
      });
      let newArr = [];
      this.goodDetail.chapterList.forEach((item) => {
        item.sections.forEach((itm) => {
          newArr.push(itm);
          this.courseList = newArr;
        });
      });
      window.addEventListener("message", this.listenerEvent, false);
    },
    // 获取地理经纬度
    getGisInfo() {
      AMap.plugin("AMap.Geolocation", () => {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
        });
        geolocation.getCurrentPosition((status, result) => {
          if (status == "complete") {
            this.getAddress(result.position);
          }
        });
      });
    },
    // 逆向地理编码
    getAddress(position) {
      console.log(position);
      AMap.plugin("AMap.Geocoder", () => {
        var geocoder = new AMap.Geocoder({
          city: "010",
        });
        geocoder.getAddress([position.lng, position.lat], (status, result) => {
          if (status === "complete" && result.info === "OK") {
            geocoder_CallBack(result);
          }
        });
        var geocoder_CallBack = (data) => {
          var address = data.regeocode.formattedAddress; //返回地址描述
          console.log(address);
        };
      });
    },

    // 获取视频播放时间节点
    getVideoTimeNode() {
      let data;
      this.goodDetail.chapterList.forEach((item) => {
        item.sections.forEach((itm) => {
          if (itm.id == this.sectionId) {
            data = itm;
          }
        });
      });
      this.duration = moment.duration(data.duration).asSeconds();
      let params = {
        sectionId: this.sectionId,
        courseId: this.goodDetail.id,
        duration: this.duration,
        userId: this.$sessionStore.getUserId(),
        packageId: this.$route.query.packageId,
        studyTime: data.studyTime,
        studyId: this.studyId,
      };
      sessionStorage.setItem("studyId", this.studyId);
      sessionStorage.setItem("sectionId", this.sectionId);
      this.$api.get("/web/qrCode/getTakeTimeList", params, (res) => {
        if (res.code == "SUCCESS") {
          this.studyList = res.data;
          this.faceFlag = true;
        }
      });
    },

    // 监听回调 根据返回的时间数组跳人脸识别
    listenerEvent(e) {
      const patt = /getCurrentTime/g;
      if (patt.test(e.data)) {
        let time = Math.floor(e.data.replace("getCurrentTime:", ""));
        if (time == this.duration) {
          this.faceFlag = false;
          let idx = this.courseList.findIndex(
            (item) => item.id == this.sectionId
          );
          if (idx == this.courseList.length - 1) {
            this.startStudy(this.courseList[0].id);
            window.frames[0].postMessage("pause", "*");
          } else {
            this.startStudy(this.courseList[idx + 1].id);
            window.frames[0].postMessage("play", "*");
          }
        }
        if (this.studyList.includes(time)) {
          this.faceFlag = false;
          sessionStorage.setItem("playTime", time);
          window.frames[0].postMessage("pause", "*");
          this.callFaceRecognition();
        }
      } else if (e.data == "SUCCESS") {
        this.faceDialogFlag = false;
        window.frames[0].postMessage("play", "*");
        setTimeout(() => {
          this.faceFlag = true;
        }, 1000);
      } else if (e.data == "FAIL") {
        this.faceFlag = false;
        this.callFaceRecognition();
      }
    },

    // 调用人脸识别接口
    callFaceRecognition() {
      let params = {};
      params.username = this.$sessionStore.getRealName();
      params.idCard = this.$sessionStore.getIdcard();
      params.linkUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/index.html#/" +
        "mobileVideoFace";
      // params.linkUrl =
      //   window.location.protocol +
      //   "//" +
      //   window.location.host +
      //   "/#/" +
      //   "mobileVideoFace";
      this.$api.get("/user/brainBaiduFace", params, (res) => {
        if (res.code == "SUCCESS") {
          this.faceUrl = res.data.replace(
            "brain.baidu.com",
            "hunanzyjn.chinahrt.com"
          );
          let token_group = [
            this.faceUrl.match(/verify_token=(\S*)&/)[1],
            this.faceUrl.match(/access_token=(\S*)/)[1],
          ];
          sessionStorage.setItem("VideoToken", JSON.stringify(token_group));
          this.faceDialogFlag = true;
        }
      });
    },
    //判断是否登录
    judgeLogin() {
      var userId = this.$sessionStore.getUserId();
      if (typeof userId != "undefined" && userId != "" && userId != null) {
        return true;
      }
      this.$sessionStore.clearSession();
      return false;
    },
    //开始学习
    startStudy(sectionId) {
      console.log(sectionId);
      if (sectionId) {
        this.sectionId = sectionId;
      }
      if (this.judgeLogin()) {
        if (!this.goodDetail.goodsStudyId) {
          //先调用加入学习
          this.$axiosPackag.getMessageByAxios(
            "GET",
            "/web/goodsMobile/freeGoodsPutIn",
            { goodsId: this.goodDetail.id },
            null,
            null,
            (resD) => {
              if (resD) {
                //开始播放
                this.goodDetail.goodsStudyId = resD;
                this.play(resD);
              }
            },
            (err) => {
              Toast("请前往电脑端进行课程购买");
            },
            false
          );
        } else {
          this.play(this.goodDetail.goodsStudyId);
        }
      } else {
        this.$router.push({
          path: "/mobileLogin",
          query: { redirect: this.$router.currentRoute.fullPath },
        });
      }
    },
    play(studyId) {
      this.studyId = studyId;
      if (
        this.goodDetail.chapterList &&
        this.goodDetail.chapterList.length > 0 &&
        this.goodDetail.chapterList[0].sections
      ) {
        for (let i = 0; i < this.goodDetail.chapterList.length; i++) {
          for (
            let j = 0;
            j < this.goodDetail.chapterList[i].sections.length;
            j++
          ) {
            if (
              this.sectionId == this.goodDetail.chapterList[i].sections[j].id
            ) {
              this.goodDetail.chapterList[i].sections[j].activess = true;
            } else {
              this.goodDetail.chapterList[i].sections[j].activess = false;
            }
          }
        }
      }
      var studyBySort = this.goodDetail.studyBySort;
      var url =
        this.goodDetail.videoPlayUrl +
        "/videoPlay/play?courseId=" +
        this.goodDetail.id +
        "&sectionId=" +
        this.sectionId +
        "&client_id=rx&client_ts=" +
        new Date().getTime() +
        "&ifPauseBlur=1&proxy_url=" +
        this.goodDetail.webProxyUrl +
        "/proxy.html&ifDrag=0&business_id=" +
        this.goodDetail.businessId +
        "&autoPlay=1&allow_study_same_time=1&receive_course_record_url=" +
        this.goodDetail.receiveCourseyunRecordUrl +
        "&signId=" +
        studyId +
        "&ifPauseAd=0" +
        "&studyBySort=" +
        studyBySort +
        "&ifppt=0&ifKeypoint=0";
      // this.previewUrl = url.replace('https', 'http')
      this.previewUrl = url;
      this.$axiosPackag.getMessageByAxios(
        "post",
        "/userStudyResource/addStudyLog",
        null,
        {
          courseId: this.goodDetail.id,
          sectionId: this.sectionId,
          studyId: studyId,
        },
        null,
        (resD) => {}
      );

      this.buildIframeHtml();
      this.getVideoTimeNode();
    },
    //播放
    /*   play(sectionId){
                          if(this.judgeLogin()){
                             // 加入学习
                              this.addStudy(sectionId);
                          }

                      },*/
    //将秒转化为时分秒
    formateSeconds(endTime) {
      this.endDurationTime = endTime;
      let secondTime = parseInt(endTime); //将传入的秒的值转化为Number
      let min = 0; // 初始化分
      let h = 0; // 初始化小时
      let result = "";
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        min = parseInt(secondTime / 60); //获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60); //获取秒数，秒数取佘，得到整数秒数
        if (min > 60) {
          //如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60); //获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60); //获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, "0")}:${min
        .toString()
        .padStart(2, "0")}:${secondTime.toString().padStart(2, "0")}`;
      return result;
    },
    setIframeHeight(iframe) {
      try {
        if (iframe) {
          var iframeWin =
            iframe.contentWindow || iframe.contentDocument.parentWindow;
          if (iframeWin.document.body) {
            iframe.height =
              iframeWin.document.documentElement.scrollHeight ||
              iframeWin.document.body.scrollHeight;
          }
        }
      } catch (e) {}
    },
    /** 要动态改变整个iframe,否则回退到上一页需要多次 */
    buildIframeHtml() {
      if (!this.$util.isBlackStr(this.previewUrl)) {
        this.iframeHtml =
          '<iframe src="' +
          this.previewUrl +
          '" id="iframea" allow="autoplay" width="100%" height="100%" allowfullscreen="true" scrolling="no"  border="0" frameborder="0" ></iframe>';
      } else {
        this.iframeHtml =
          '<img  :src="' +
          this.previewImg +
          '" scrolling="no" allow="autoplay"  width="100%" height="100%"/>';
      }
      this.setIframeHeight(document.getElementById("iframea"));
    },
    getSession() {
      this.$axiosPackag.getMessageByAxios(
        "GET",
        "/session/getSession",
        null,
        null,
        null,
        (resD) => {
          if (resD) {
            this.$sessionStore.initSession(resD);
          }
        }
      );
    },
  },
  mounted() {
    this.getGisInfo();
    setInterval(() => {
      this.getSession();
    }, 300000);
    //        let studyId=this.$route.query.studyId;
    let params = {
      id: this.$route.query.id,
      packageId: this.$route.query.packageId,
    };
    this.$axiosPackag.getMessageByAxios(
      "GET",
      "/web/goodsMobile/getGoodsDetail",
      params,
      null,
      null,
      (resD) => {
        this.isAdd = resD.isAdd;
        this.isFree = resD.isfree;
        if (resD) {
          this.goodDetail = resD;
          this.showFaceDialog();
          if (
            this.goodDetail.chapterList &&
            this.goodDetail.chapterList.length > 0 &&
            this.goodDetail.chapterList[0].sections
          ) {
            for (let i = 0; i < this.goodDetail.chapterList.length; i++) {
              if (this.$util.isBlackStr(this.goodDetail.chapterList[i].name)) {
                this.goodDetail.chapterList[i].name = "第" + (i + 1) + "章";
              }
              for (
                let j = 0;
                j < this.goodDetail.chapterList[i].sections.length;
                j++
              ) {
                if (this.$util.isBlackStr(this.sectionId)) {
                  if (
                    this.goodDetail.chapterList[i].sections[j].studyStatus ==
                      "未学习" ||
                    this.goodDetail.chapterList[i].sections[j].studyStatus ==
                      "学习中"
                  ) {
                    this.sectionId =
                      this.goodDetail.chapterList[i].sections[j].id;
                  }
                }

                this.goodDetail.chapterList[i].sections[j].duration =
                  this.formateSeconds(
                    this.goodDetail.chapterList[i].sections[j].duration
                  );
                this.activeNames.push(
                  this.goodDetail.chapterList[i].sections[j].name
                );
              }
              this.activeNames.push(this.goodDetail.chapterList[i].name);
            }
            if (this.$util.isBlackStr(this.sectionId)) {
              this.sectionId = this.goodDetail.chapterList[0].sections[0].id;
            }
            if (!this.$util.isBlackStr(this.goodDetail.goodsStudyId)) {
              this.play(this.goodDetail.goodsStudyId);
            }
          }
          if (
            null != this.goodDetail.categoryInfoList &&
            this.goodDetail.categoryInfoList.length > 0
          ) {
            let firstCate = "";
            for (let j = 0; this.goodDetail.categoryInfoList.length; j++) {
              if (this.goodDetail.categoryInfoList[j].pid == 0) {
                firstCate = this.goodDetail.categoryInfoList[j].name;
                break;
              }
            }
            this.goodDetail.firstCate = firstCate;
          }

          if (this.$util.isBlackStr(this.previewUrl)) {
            this.previewImg = this.goodDetail.pictureShowUrl;
          }
        }
      }
    );
    this.actives = this.$route.query.actives;
  },
  destroyed() {
    clearInterval(this.faceTimeout);
  },
};
</script>

<style scoped>
/* 人脸识别iframe标签样式 */
.faceframe {
  width: 100%;
  height: 500px;
  border: none;
}

.faceframe ::-webkit-scrollbar {
  display: none;
}

.moileParticulars {
  width: 100%;
  height: 100%;
  color: #2c333a;
  background: #f2f2f2;
}

.van-tabs {
  background-color: #fff;
  height: auto;
  overflow: hidden;
}

.van-tabs /deep/ .van-tab span {
  font-size: 0.3rem;
  line-height: 0.9rem;
}

.van-tabs--line /deep/ .van-tabs__wrap {
  border-bottom: 0.01rem solid #f2f3f5;
  height: 0.9rem;
}

.moileParticulars.van-tabs__line {
  width: 2rem !important;
}

.van-collapse /deep/ .van-cell {
  padding: 0.25rem 0.32rem 0;
  height: 0.9rem;
}

.van-collapse /deep/ .van-collapse-item .van-cell__title > span {
  display: inline-block;
  width: 6.3rem;
  font-size: 0.26rem;
  line-height: 0.3rem;
  color: #73787e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.van-collapse /deep/ .van-collapse-item__content {
  padding-top: 0;
}

.van-overlay {
  background: none;
}

.particularsTab3 .comments {
  padding: 0.3rem;
  border-radius: 0.15rem;
}

.videoTitle {
  color: #000000;
  font-weight: bold;
  font-size: 0.533333rem;
  width: 8.92rem;
  margin: 0 auto;
  margin-top: 0.4rem;
  margin-bottom: 0.426667rem;
}

.videoLabal {
  font-size: 0.32rem;
  font-weight: bold;
  color: #1569d4;
  height: 0.453333rem;
  border: 1px solid rgba(21, 105, 212, 1);
  border-radius: 0.053333rem;
  padding: 0 0.08rem;
  text-align: center;
  margin-top: 0.133333rem;
}

.time {
  font-size: 0.293333rem;
  color: #999999;
  font-weight: 400;
}

.LabelTime {
  padding: 0 0.4rem;
  overflow: hidden;
  padding-bottom: 0.4rem;
}

.particularsTitle {
  margin-bottom: 0.24rem;
  background: #fff;
  overflow: hidden;
}

.introduce_he h5 {
  font-size: 0.426667rem;
  font-weight: 500;
  color: #2d333a;
  margin-top: 0.56rem;
  padding-left: 0.426667rem;
  padding-right: 0.64rem;
}

.introduce_he p {
  font-size: 0.373333rem;
  line-height: 0.586667rem;
  color: #666666;
  font-weight: 500;
  text-indent: 0;
  padding-left: 0.426667rem;
  padding-right: 0.64rem;
}

.coursePoint {
  display: inline-block;
}

.coursePoint img {
  width: 0.08rem;
  height: 0.4rem;
  display: inline-block;
}

.van-nav-bar .van-icon {
  color: #000;
}

.van-nav-bar__text {
  color: #000;
}

.van-nav-bar__title {
  color: #000;
}

.van-nav-bar {
  background: #eee;
}

.van-nav-bar__left {
  color: #000;
}

.divderLine {
  border-bottom: 1px solid #d9dce1;
  width: 100%;
  display: inline-block;
}

.nameLabel {
  width: 6.68rem;
}

.teacherLabel_introduce {
  padding-left: 0.426667rem;
  padding-right: 0.64rem;
  overflow: hidden;
}

.moileParticulars .video {
  width: 100%;
  height: 5.6rem;
}

.previewImg {
  display: inline-block;
  width: 100%;
  height: 5.6rem;
}

.playVideo {
  width: 1.653333rem;
  height: 1.653333rem;
  position: absolute;
  top: 2.2rem;
  left: 4.173333rem;
}

.play_shadow {
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  height: 5.6rem;
  width: 100%;
  overflow: hidden;
  z-index: 101;
}

.timeClock img {
  width: 0.306667rem;
  height: 0.32rem;
  display: inline-block;
  margin-right: 0.12rem;
}

.addStudy {
  background: #053e76;
  color: #fff;
  border: none;
  margin: 0 0.266667rem;
  padding: 0.08rem 0.08rem;
  margin-right: 0;
}

.particularsTab p {
  font-size: 0.373333rem;
  line-height: 0.586667rem;
  color: #666666;
  font-weight: 500;
  text-indent: 0;
  padding-left: 0.426667rem;
  padding-right: 0.426667rem;
  text-indent: 2em;
  word-break: break-all;
}

.h5mb {
  margin-bottom: 0.266667rem;
}

.van-cell__title span {
  font-size: 0.4rem;
}

.chaperList_he {
  width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.28rem;
  font-size: 0.36rem;
}

.videoText {
  margin-left: 0.506667rem;
}

.timeDown,
.time {
  font-size: 0.36rem;
}

.van-collapse-item {
  border-bottom: 2px solid #f2f2f2;
}

.video_down {
  width: 0.333333rem;
  height: 0.306667rem;
  margin-right: 0.16rem;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: 0;
}

.particularsTab2 .finish.activess .time {
  color: dodgerblue;
}

.timeUp span img {
  width: 0.426667rem;
  height: 0.426667rem;
}
</style>



// WEBPACK FOOTER //
// MobileCourseDetail.vue?fbfb4588